import React, { FunctionComponent } from 'react'
import styled from 'styled-components'
import { GQLShopFieldsContentsDetailButtonLayout } from '../generated/graphql'
import { Button } from './button'
import { useModal } from '../hooks/use-modal'
import { Popup } from './popup'

const Outer = styled.div``

const RedButton = styled(Button)`
  background-color: #8D0D0D;
  border: 0 none;
  color: white;
  margin-top: 2.1875rem;
  margin-bottom: 1.8875rem;
  &[href=""],&:not([href]) {
    background-color: #919191;
    pointer-events: none;
  }
`

const Note = styled.div`
  font-size: 0.88rem;
  color: #000;
  margin-top: -0.5rem;
  text-align: center;
  margin-bottom: 2.1875rem;
`

type ShopDetailButtonProps = {
  data: DeepPartial<GQLShopFieldsContentsDetailButtonLayout>
}
export const ShopDetailButton: FunctionComponent<ShopDetailButtonProps> = ({data}) => {
  const {open} = useModal()
  return <Outer>
    <RedButton href={data.url ?? undefined} onClick={e => {
      const target = e.target
      if(target instanceof HTMLAnchorElement && target.origin !== location.origin && !/^(https:\/\/maps.app.goo.gl\/|https:\/\/www.google.com\/maps\/)/.test(target.href)){
        e.preventDefault()
        open(({resolve}) => <Popup onClose={resolve} data={{
          siteName: target.href,
          url: target.href
        }} />)
      }
    }}>
      {data.label || '詳しくはこちら'}
    </RedButton>
    {
      data.note && <Note>{data.note}</Note>
    }
  </Outer>
}
